import React, { useState, useEffect } from 'react';

const CurtainOpening = ({ onComplete, color = 'purple' }) => {
  const [isOpening, setIsOpening] = useState(true);

  useEffect(() => {
    // Enhanced timing: Quick pause (0.5s), then prolonged opening (3s)
    const timer = setTimeout(() => {
      setIsOpening(false);
      setTimeout(() => {
        onComplete();
      }, 3000); // 3 second prolonged opening
    }, 500); // 0.5 second pause

    return () => clearTimeout(timer);
  }, [onComplete]);

  const curtainColors = {
    purple: 'from-purple-900 via-red-900 to-purple-900',
    red: 'from-red-900 via-purple-900 to-red-900',
    gold: 'from-yellow-900 via-orange-900 to-yellow-900'
  };

  return (
    <div className="fixed inset-0 z-50 overflow-hidden">
      {/* Left Curtain - Prolonged 3 second opening */}
      <div 
        className={`absolute top-0 left-0 bottom-0 bg-gradient-to-r ${curtainColors[color]} transition-all duration-[3000ms] ease-out ${
          isOpening ? 'w-1/2' : 'w-0'
        }`}
        style={{
          boxShadow: isOpening ? '20px 0 40px rgba(0, 0, 0, 0.8)' : 'none'
        }}
      >
        <div className="absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-black/50 to-transparent"></div>
      </div>

      {/* Right Curtain - Prolonged 3 second opening */}
      <div 
        className={`absolute top-0 right-0 bottom-0 bg-gradient-to-l ${curtainColors[color]} transition-all duration-[3000ms] ease-out ${
          isOpening ? 'w-1/2' : 'w-0'
        }`}
        style={{
          boxShadow: isOpening ? '-20px 0 40px rgba(0, 0, 0, 0.8)' : 'none'
        }}
      >
        <div className="absolute left-0 top-0 bottom-0 w-8 bg-gradient-to-r from-black/50 to-transparent"></div>
      </div>

      {/* Central Opening Light */}
      <div 
        className={`absolute top-0 left-1/2 bottom-0 transform -translate-x-1/2 transition-all duration-2000 ease-out ${
          isOpening ? 'w-0' : 'w-full'
        }`}
        style={{
          background: 'radial-gradient(ellipse at center, rgba(255, 255, 255, 0.1) 0%, transparent 70%)'
        }}
      />

    </div>
  );
};

export default CurtainOpening;